var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5.99927V3.99927C13.5 3.73405 13.3946 3.4797 13.2071 3.29216C13.0195 3.10462 12.7652 2.99927 12.5 2.99927H9.83331",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 2.99927H1.5C1.23478 2.99927 0.98043 3.10462 0.792893 3.29216C0.605357 3.4797 0.5 3.73405 0.5 3.99927V14.9993C0.5 15.2645 0.605357 15.5188 0.792893 15.7064C0.98043 15.8939 1.23478 15.9993 1.5 15.9993H5.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61403 3.65727C9.58076 3.75684 9.51702 3.84344 9.43185 3.90481C9.34667 3.96619 9.24435 3.99923 9.13936 3.99927H4.86069C4.75571 3.99923 4.65339 3.96619 4.56821 3.90481C4.48303 3.84344 4.4193 3.75684 4.38603 3.65727L3.71936 1.65727C3.69417 1.58209 3.68724 1.50199 3.69915 1.4236C3.71106 1.3452 3.74147 1.27078 3.78785 1.20647C3.83424 1.14217 3.89528 1.08983 3.96591 1.0538C4.03654 1.01777 4.11474 0.999076 4.19403 0.999269H9.80603C9.88532 0.999076 9.96352 1.01777 10.0341 1.0538C10.1048 1.08983 10.1658 1.14217 10.2122 1.20647C10.2586 1.27078 10.289 1.3452 10.3009 1.4236C10.3128 1.50199 10.3059 1.58209 10.2807 1.65727L9.61403 3.65727Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.99927H8.5C7.94772 7.99927 7.5 8.44698 7.5 8.99927V14.9993C7.5 15.5516 7.94772 15.9993 8.5 15.9993H14.5C15.0523 15.9993 15.5 15.5516 15.5 14.9993V8.99927C15.5 8.44698 15.0523 7.99927 14.5 7.99927Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.99927H13.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.9993H13.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.9993H11",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3097097c988adee15b7e9b329725c0bb.svg";
export { ForwardRef as ReactComponent };